import { AbstractCommand } from 'src/models/command';

class DelayTheAlarmToASpecificTimestampCommand extends AbstractCommand {
	readonly name = 'IFS_Alarm_Command_Command_DelayTheAlarmToASpecificTimestampCommand';

	public constructor(type: string, id: number, timestamp: number) {
		super();
		this.parameters = {
			id: id,
			timestamp: timestamp,
			type: type,
		};
	}
}

export { DelayTheAlarmToASpecificTimestampCommand };
